import {Component, EventEmitter, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {
  title: string;
  message: string;
  confirm: string;
  dismiss: string;
  simpleClose: boolean;
  dismissWithLoading: boolean;

  loading: boolean;
  onClose = new EventEmitter();

  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.loading = false;
  }
  ngOnInit(): void {
    if (this.data.confirm === undefined ) {
      this.data.confirm = 'Confirm';
    }

    if (this.data.dismiss === undefined ) {
      this.data.dismiss = 'Cancel';
    }
  }

  close() {
    this.dialogRef.close();
  }

  closeWithLoading() {
    if (this.data.dismissWithLoading) {
      this.loading = true;
      this.onClose.emit();
    } else {
      this.dialogRef.close(true);
    }
  }

}
